module.exports = __webpack_public_path__ + "static/img/Jai-Newcombe.b6ae583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jai-Newcombe.jpg
// module id = G6gs
// module chunks = 0